import { type MenuItem } from '@common/clients/api';

import { DropdownLink } from './atoms/DropdownLink';

import styles from './navigation.module.scss';

interface Props {
    menu: MenuItem[];
}

export const Navigation = ({ menu }: Props) => {
    return (
        <nav className="navigation">
            <ul className={styles['navigation']}>
                {menu.map((item, index) => {
                    return (
                        <li className={styles['list-item']} key={index}>
                            <DropdownLink menuItem={item} />
                        </li>
                    );
                })}
            </ul>
        </nav>
    );
};
